import request from '@/utils/request'
import { ResultData } from '../types'
import { GLOBAL_URL } from '@/enums'
import { Partner } from './types'

export const getPartnerInfo = (loading): Promise<ResultData<Partner.Info>> => {
    return request({
        url: GLOBAL_URL.CopartnerStats,
        method: 'post',
        data: {},
        loading,
    })
}
export const partnerUpgrade = (): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.CopartnerUpgrade,
        method: 'post',
        data: {},
    })
}
export const getPartnerRank = (params: Partner.Page): Promise<ResultData<Partner.RankTop>> => {
    return request({
        url: GLOBAL_URL.CopartnerRankM,
        method: 'post',
        data: params,
        loading: false,
    })
}
export const getPartnerRankTotal = (params: Partner.Page): Promise<ResultData<Partner.RankTop>> => {
    return request({
        url: GLOBAL_URL.CopartnerRank,
        method: 'post',
        data: params,
        loading: false,
    })
}

export const getEarnedLog = (params: Partner.Page): Promise<ResultData<Partner.Contribution>> => {
    return request({
        url: GLOBAL_URL.CopartnerEarnedLog,
        method: 'post',
        data: params,
        loading: false,
    })
}
export const getEarnedPlayer = (params: Partner.Page): Promise<ResultData<Partner.RankTop>> => {
    return request({
        url: GLOBAL_URL.CopartnerEarnedPlayer,
        method: 'post',
        data: params,
        loading: false,
    })
}
export const getearnedTeam = (params: Partner.Page): Promise<ResultData<Partner.RankTop>> => {
    return request({
        url: GLOBAL_URL.CopartnerEarnedTeam,
        method: 'post',
        data: params,
        loading: false,
    })
}
// 邀请列表
export const getPartnerInvite = (params: Partner.Page): Promise<ResultData<Partner.Invite[]>> => {
    return request({
        url: GLOBAL_URL.CopartnerInviteList,
        method: 'post',
        data: params,
        loading: false,
    })
}
// 团伙列表
export const getCopartnerSubList = (params: Partner.Page): Promise<ResultData<Partner.Invite[]>> => {
    return request({
        url: GLOBAL_URL.CopartnerSubList,
        method: 'post',
        data: params,
        loading: false,
    })
}
// 设置下级
export const setCopartnerRate = (params: { uid: number; rate: number }): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.CopartnerExtend,
        method: 'post',
        data: params,
    })
}
// 更改返利
export const changeCopartnerRate = (params: { uid: number; rate: number }): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.CopartnerRate,
        method: 'post',
        data: params,
    })
}
//
export const copartnerApply = (): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.CopartnerApply,
        method: 'post',
        data: {},
    })
}
export const copartnerRespond = (agree: boolean): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.CopartnerRespond,
        method: 'post',
        data: {
            agree,
        },
    })
}
export const uploadAvatarPic = (url: string): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.UpdateAvatar,
        method: 'post',
        data: {
            url,
        },
    })
}
export const setAvatarPic = (index: number): Promise<{ code: number; avatar: string }> => {
    return request({
        url: GLOBAL_URL.SelectAvatar,
        method: 'post',
        data: {
            index,
        },
    })
}
export const CheckAvatarProgress = (): Promise<{ status: string; avatarList: string[] }> => {
    return request({
        url: GLOBAL_URL.CheckAvatarProgress,
        method: 'post',
        data: {},
    })
}
export const copartnerRelation = (): Promise<{ code: number }> => {
    return request({
        url: GLOBAL_URL.CopartnerRelation,
        method: 'post',
        data: {},
    })
}
